/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentScenarioControllerListQueryResponse, IncidentScenarioControllerListQueryParams } from "../../models/incidentAgentController/IncidentScenarioControllerList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentScenarioControllerList } from "../../clients/incident-agentService/incidentScenarioControllerList";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentScenarioControllerListQueryKey = (params: IncidentScenarioControllerListQueryParams = {}) => [{
  url: '/api/v1/incident-agent/scenarios'
}, ...(params ? [params] : [])] as const;
export type IncidentScenarioControllerListQueryKey = ReturnType<typeof incidentScenarioControllerListQueryKey>;
export function incidentScenarioControllerListQueryOptions(params?: IncidentScenarioControllerListQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentScenarioControllerListQueryKey(params);
  return queryOptions<IncidentScenarioControllerListQueryResponse, ResponseErrorConfig<Error>, IncidentScenarioControllerListQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentScenarioControllerList(params, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/scenarios}
 */
export function useIncidentScenarioControllerList<TData = IncidentScenarioControllerListQueryResponse, TQueryData = IncidentScenarioControllerListQueryResponse, TQueryKey extends QueryKey = IncidentScenarioControllerListQueryKey>(params?: IncidentScenarioControllerListQueryParams, options: {
  query?: Partial<QueryObserverOptions<IncidentScenarioControllerListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentScenarioControllerListQueryKey(params);
  const query = useQuery({
    ...incidentScenarioControllerListQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}